/**
 * Network/offline utilities for retry logic and offline handling.
 */

export const OFFLINE_ERROR_MESSAGE = 'You are offline. Please check your connection and try again.';

export const NETWORK_ERROR_MESSAGE = 'Network error. Please check your connection and try again.';

const MAX_RETRIES = 3;
const RETRY_DELAY_MS = 1000;

/**
 * Returns true if the request should be retried (network failure or server error).
 * Do not retry 401 (handled by session expiry) or 4xx client errors (except 408).
 */
export function isRetryableError(error) {
    if (!error) return false;
    if (error.response) {
        const status = error.response.status;
        if (status === 401) return false;
        if (status >= 400 && status < 500 && status !== 408) return false;
        if (status >= 500 || status === 408) return true;
        return false;
    }
    return true;
}

/**
 * Delay for retry attempt (simple fixed delay).
 */
export function getRetryDelay(attemptNumber) {
    return RETRY_DELAY_MS * attemptNumber;
}

/**
 * Max number of retries for a single request.
 */
export function getMaxRetries() {
    return MAX_RETRIES;
}
